<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import './style/index.scss';
@import url('./style/iconfont/iconfont.css');
</style>



// WEBPACK FOOTER //
// src/App.vue